import React, { useState } from "react";
import "./App.css";
import WaitlistForm from "./components/WaitlistForm";
import SurveyModal from "./components/SurveyModal";
import SuccessPage from "./components/SuccessPage";
import { supabase } from "./supabaseClient";
import { saveSurveyResponses } from "./setupSurvey";

function App() {
  const [showSurvey, setShowSurvey] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [email, setEmail] = useState("");

  const handleEmailSubmit = async (userEmail) => {
    setEmail(userEmail);

    // Save email to Supabase waitlist table immediately
    try {
      const { data, error } = await supabase
        .from("waitlist")
        .insert([{ email: userEmail }]);

      if (error) {
        console.error("Error saving to waitlist:", error);
        alert("There was an error joining the waitlist. Please try again.");
        return;
      }

      console.log("Successfully added to waitlist:", data);
      // Show survey after successfully saving email
      setShowSurvey(true);
    } catch (err) {
      console.error("Unexpected error:", err);
      alert("There was an error joining the waitlist. Please try again.");
    }
  };

  const handleSurveyComplete = async (surveyData) => {
    console.log("Survey Data:", surveyData);
    console.log("Email:", email);

    // Save survey responses to database
    try {
      // Extract question_id and option_id from survey data
      const responses = surveyData.map((answer) => ({
        question_id: answer.question_id,
        option_id: answer.option_id,
      }));

      await saveSurveyResponses(email, responses);
      console.log("Successfully saved survey responses");
    } catch (error) {
      console.error("Error saving survey responses:", error);
      // Continue to success page even if survey save fails
    }

    setShowSurvey(false);
    setShowSuccess(true);
  };

  const handleCloseSurvey = () => {
    setShowSurvey(false);
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
  };

  return (
    <div className="App">
      <WaitlistForm onSubmit={handleEmailSubmit} />
      {showSurvey && (
        <SurveyModal
          onComplete={handleSurveyComplete}
          onClose={handleCloseSurvey}
        />
      )}
      {showSuccess && (
        <SuccessPage email={email} onClose={handleCloseSuccess} />
      )}
    </div>
  );
}

export default App;
